import { useQuery } from '@tanstack/react-query';
import { accountsQueries } from '#/api/queryKeys/accountsKeys';

export function useAccount() {
  const { data, error } = useQuery({ ...accountsQueries.detail() });
  return { data: data?.data, error };
}
